// extracted by mini-css-extract-plugin
export default {"entityMap":"flipper-vault_entityMap__aZaIw","flipperVaultWebWrapper":"flipper-vault_flipperVaultWebWrapper__WYycs","flipperVaultWebList":"flipper-vault_flipperVaultWebList__rvx-U"};